import {Box} from 'platform/foundation';

import {ReactNode} from 'react';

interface AdContentCardProps {
  children: ReactNode;
}

/**
 * Shared card for the advertisement text content (title extension + description), used both
 * for the single-language layout and as the frame around the language tabs.
 */
export function AdContentCard(props: AdContentCardProps) {
  return (
    <Box padding={4} borderRadius="small" backgroundColor="palettes.neutral.20.100">
      {props.children}
    </Box>
  );
}
